<style>
.tooltip {
  opacity: 1 !important;
  background-color: rgb(0, 0, 2);
  color: white;
}

.stylett {
  text-align: right;
}

.allign {
  font-weight: bold;
  color: brown;
  background-color: black;
}
</style>

<template>
  <div class="loan">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
      
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex s12 md9">
      	 <va-card :title="$t('loans.myappliedloans')">
      	 	<template slot="actions">           
	            <va-button icon="fa fa-close" @click="$router.go(-1)">Cancel</va-button>	           
	        </template>

        <template >           
          <va-input
              :label="$t('Check off Posted on')"
              type="label"
              v-model="this.postdate"
              :readonly = "true"  
            />	           
	        </template>
       
          <va-data-table
      :fields="mode ? detailedFields : fields"
      :data="filteredData"
      :per-page="10"
          hoverable
    >
    
      <template slot="icon">
        <va-icon name="fa fa-list" color="secondary" />
      </template> 
      <template v-slot:type="props">
        {{ props.rowData.type }}
      </template>
      <template v-slot:loanNo="props">
        {{ props.rowData.loanNo }}~{{props.rowData.loantype }}
      </template>
      <template v-slot:amount="props" style="text-align: right;">
        {{ props.rowData.amount | Currency }}
      </template>

      
    </va-data-table>
    <br />
    <template  class="allign " >
      <h4>{{ $t('Total Amount :') }} {{ totalRequest  | Currency }}</h4>
      
    </template>
<br />
    <va-button  @click="moreDetails()">
                  {{ $t('Any Question?') }}
                 
                </va-button>  
      	 </va-card>
      </div>
    </div>
  
  </div>
</template>
<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>

import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  
  components: {
    ...spinners      
  },
  name: 'loan',
  name: 'App',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),   
      checkoffNo : this.$route.params.checkoffNo,
      postdate : this.$route.params.postdate,
      loading: false,
      term: null,
      loadSelect:false,
      processingError: false,
      payment_method : '',
      finalPost : '',
      details:{},
      formdata:{
        phone_no:'',
        loanType:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        ApprovalStatus:'',
        grossSalary:'',
        amount:'',
        user: '',
        
      },
      montlyrepayment:'',
      loanType:'',
      amount:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        ApprovalStatus:'',
        repaymentperiod:'',
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: '__slot:type',
        title: this.$t('Transaction type'),
        width: '30%',
        sortField: 'amount',
      }, 
      {
        name: '__slot:loanNo',
        title: this.$t('Loan Number'),
        width: '50%',
        sortField: 'Date',

      },
      {
        name: '__slot:amount',
        title: this.$t('Amount'),
        width: '20%',
        sortField: 'amount',
      },

    ]

    },
    totalRequest() {
      const result = Array.isArray(this.details)
  ? this.details.reduce((acc, item) => acc + item.amount, 0)
  : 0;
      return result;
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.details
      }
      console.log(this.term);
      return this.details.filter(item => {
        return item.description.toLowerCase().startsWith(this.term.toLowerCase()) || item.amount.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
   
    formReady () {

     },      
  },
  methods : {
    GetProduct(id) {      
      return this.loans.filter(item => item.loanType.toLowerCase() === this.id.toLowerCase());      
    },
    
    GetAmount(id) {      
      return this.details.filter(item => item.amount.toLowerCase() === this.id.toLowerCase());      
    },
    onsubmit () {

    },
    GetgeneralCheckoff () {
    
      const self = this

      self.loading = true;
      const form = {
  user:this.userData.user_id,
  checkoffNo:this.checkoffNo,
  MemberNo:this.userData.member_number
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }
      axios.post(`${self.$apiUrl}getIndividualCheckoff`, form, config)
      .then(function (res) {
          self.loadSelect = false
          self.loading = false
          
          res = res.data
          console.log(res)
          self.details = res.slice()
          console.log(self.details)
      })
      .catch(function (error) {
          console.log(error)
      })
    },

 
    moreDetails () {
      this.$router.push({name: 'crm-MemberInquiry'});
},
  },
  created () { 
    this.GetgeneralCheckoff();
    
  this.postdate;
 
  }
}
</script>